import Swal from 'sweetalert2';
import { api } from 'api';
import { createActions, handleActions } from 'redux-actions'
import { goBack } from 'react-router-redux'
import { initialize as initializeForm } from 'redux-form'
import { push } from 'react-router-redux';
const url = '';

const LOADER_SCHEDULE = 'LOADER_SCHEDULE';
const SET_DATA_SCHEDULE = 'SET_DATA_SCHEDULE';
const SET_PAGE_SCHEDULE = 'SET_PAGE_SCHEDULE';
const SET_UPDATE_DATA_SCHEDULE ='SET_UPDATE_DATA_SCHEDULE';
const SET_BUSCADOR_SCHEDULE = 'SET_BUSCADOR_SCHEDULE';
const SET_FILTRO_SCHEDULE = 'SET_FILTRO_SCHEDULE';

const listar = (page = 1) =>  (dispatch, getStore) => {    
    dispatch({type: LOADER_SCHEDULE, cargando: true});
    const store = getStore();
    const search = store.schedule.buscador;
    const filtro = store.schedule.filtro_schedule;
    let params = {page, search};

    if(filtro){
        params[''] = filtro
    }
    api.get(`${url}`, params).catch((error) => {
        dispatch({type: LOADER_SCHEDULE, cargando: false});
        Swal(
            'Error',
            error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).then((data) => {
        if(data){
            dispatch({type: SET_DATA_SCHEDULE, data});
            dispatch({type: SET_PAGE_SCHEDULE, page});
        }
        dispatch({type: LOADER_SCHEDULE, cargando: false});
    })
};
const detail = id => (dispatch, getState) =>{
    dispatch({type: LOADER_SCHEDULE, cargando: true});
    api.get(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_SCHEDULE, cargando: false});
        if(error.statusCode  === 404){
            dispatch(push('/'))
        }
    }).then((data) => {
        dispatch({type: LOADER_SCHEDULE, cargando: false});
        if(data){
            dispatch({type: SET_UPDATE_DATA_SCHEDULE, updateData: data});
            dispatch(initializeForm('schedule', data))
        }
    })
}

const create = () => (dispatch, getStore) => {
    const formData = getStore().form.schedule.values;
    dispatch({type: LOADER_SCHEDULE, cargando: true})
    api.post(`${url}`, formData).then((data) => {
        dispatch({type: LOADER_SCHEDULE, cargando: false})
        Swal('Éxito', 'Se ha creado la cita.', 'success')
        .then(() => {
            dispatch(push('/'))
        })
    }).catch((error) => {
        dispatch({type: LOADER_SCHEDULE, cargando: false})
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).finally(() => {
        dispatch({type: LOADER_SCHEDULE, cargando: false})
    });
};

const update = () => (dispatch, getStore) => {
    const formData = _.cloneDeep(getStore().form.schedule.values);
    dispatch({type: LOADER_SCHEDULE, cargando: true});
    api.put(`${url}/${formData.id}`, formData)
    .then((data) => {
        dispatch({type: LOADER_SCHEDULE, cargando: false});
        if(data){
            Swal(
                'Éxito',
                'Datos editados correctamente.',
                'success'
            ).then(() => {
                dispatch(push('/'));
            })
        }
    })
    .catch((error) =>{
        dispatch({type: LOADER_SCHEDULE, cargando: false});
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, verifique los datos.',
            'error'
        )
        if(error.statusCode === 404){
            dispatch(push('/'));
        }
    })
}
const destroy = (id) => (dispatch, getStore) => {
    dispatch({type: LOADER_SCHEDULE, cargando: true});
    api.eliminar(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_SCHEDULE, cargando: false});
        Swal('Error', 'No se ha logrado borrar el registro.', 'error')
            .then(() => {
                dispatch(listar(1));
        })
    }).then((data) => {
        dispatch({type: LOADER_SCHEDULE, cargando: false});
        Swal('Éxito', 'Se ha eliminado correctamente.', 'success')
            .then(() => {
                dispatch(listar(1));
            })
    })
}

const search = (search) => (dispatch, getStore) => {
    dispatch({type: SET_BUSCADOR_SCHEDULE, buscador: search});
    dispatch(listar(1));
};
const filtro = (filtro) => (dispatch, getStore) => {
    if (filtro == 0){
        filtro = null
    }
    dispatch({type: SET_FILTRO_SCHEDULE, filtro_schedule: filtro});
    dispatch(listar(1));
};
export const actions = {
    listar,
    detail,
    create,
    update,
    destroy,
    search,
    filtro
};
export const reducer = {
    [LOADER_SCHEDULE]: (state, { cargando }) => {
        return {...state, cargando }
    },
    [SET_DATA_SCHEDULE]: (state, { data }) => {
        return {...state, data }
    },
    [SET_PAGE_SCHEDULE]: (state, { page }) => {
        return {...state, page }
    },
    [SET_UPDATE_DATA_SCHEDULE]: (state, { updateData }) => {
        return {...state, updateData }
    },
    [SET_BUSCADOR_SCHEDULE]: (state, { buscador }) => {
        return {...state, buscador }
    },
    [SET_FILTRO_SCHEDULE]: (state, { filtro_schedule }) => {
        return {...state, filtro_schedule }
    },
}
export const initialState = {
    cargando: false,
    page: 1,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: [],
    },
    buscador: '',
    filtro_schedule: null,
    updateData: {},
};
export default handleActions(reducer, initialState)